import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeItemStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    disabled = _this$get.disabled,
    className = _this$get.className,
    hideOnSelect = _this$get.hideOnSelect,
    _isFocus = _this$get._isFocus;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-dropdown-item"] = true, _classNameObj[k + "-disabled"] = disabled, _classNameObj[className] = className, _classNameObj[k + "-hover"] = this.keyboard.isFocus.value, _classNameObj[makeItemStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'ev-click': this.onClick,
    'ev-mouseenter': this.keyboard.onMouseEnter,
    'ev-mouseleave': this.keyboard.onMouseLeave
  }), children);
}
;